import { z } from 'zod';
export const MAX_BULK_TASK_COUNT = 500;
export const HumanTaskBulkActionBodySchema = z.object({
    humanTaskIds: z
        .array(z.uuid())
        .min(1)
        .max(MAX_BULK_TASK_COUNT)
        .refine((ids) => new Set(ids).size === ids.length, {
        message: 'humanTaskIds must be unique',
    }),
});
export var BulkTaskStatus;
(function (BulkTaskStatus) {
    BulkTaskStatus["Succeeded"] = "Succeeded";
    BulkTaskStatus["Failed"] = "Failed";
})(BulkTaskStatus || (BulkTaskStatus = {}));
export const BulkTaskResultSchema = z.object({
    humanTaskId: z.uuid(),
    status: z.enum(BulkTaskStatus),
    error: z.string().optional(),
});
export const HumanTaskBulkActionResponseSchema = z.object({
    results: z.array(BulkTaskResultSchema),
    summary: z.object({
        successCount: z.number().int().nonnegative(),
        failureCount: z.number().int().nonnegative(),
    }),
});
//# sourceMappingURL=bulk.js.map